import { render } from "./ImgViewer.vue?vue&type=template&id=765da9f3"
import script from "./ImgViewer.vue?vue&type=script&lang=js"
export * from "./ImgViewer.vue?vue&type=script&lang=js"

import "./ImgViewer.vue?vue&type=style&index=0&id=765da9f3&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__